import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Unit from "../views/Unit.vue";
import Book from "../views/Book.vue";
import Help from "../views/Help.vue";
import ThankYou from "../views/ThankYou.vue";
import NProgress from "nprogress";

Vue.use(VueRouter);

const routes = [{
        path: "/",
        name: "Home",
        component: Home,
    },
    {
        path: "/unit/:str_unit_code",
        name: "Unit",
        component: Unit,
    },
    {
        path: "/book/:str_unit_code",
        name: "Book",
        component: Book,
    },
    {
        path: "/help",
        name: "Help",
        component: Help,
    },
    {
        path: "/thank-you/:dppostback",
        name: "ThankYou",
        component: ThankYou,
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else if (to.hash) {
            return {
                selector: to.hash
            }
        } else {
            return {
                x: 0,
                y: 0,
            }
        }
    }
});

router.beforeEach((to, from, next) => {
    document.title = `${to.name} - RentEase`;
    next();
});

router.beforeResolve((to, from, next) => {
    if (to.name) {
        NProgress.start();
    }
    next();
});

router.afterEach(() => {
    NProgress.done();
});

export default router;